(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lat-cinta-fotos"] && !Shopify.designMode) return;
  try {
    
  /*
   * L'Atelier 33 — Cinta de fotos.
   *
   * Mismo motor que la cinta de reels: la cinta es un scroller de verdad y el avance lo
   * empuja este código sobre `scrollLeft`. Se hizo así, y no con una animación CSS, porque
   * la cinta tiene que PARARSE al pasar el ratón y poder ARRASTRARSE con la manita — dos
   * cosas imposibles mientras el navegador anima el elemento él mismo.
   */
  if (!customElements.get('lat-cinta-fotos')) {
    const UMBRAL_ARRASTRE = 5; // px que hay que mover para que deje de contar como clic

    class LatCintaFotos extends HTMLElement {
      connectedCallback() {
        this.pista = this.querySelector('[data-pista]');
        if (!this.pista || this.iniciado) return;
        this.iniciado = true;

        const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.velocidadBase = Number(this.dataset.velocidad || 40);
        if (this.dataset.direccion === 'derecha') this.velocidadBase *= -1;
        // Con el movimiento reducido o el auto apagado, la cinta se queda quieta:
        // se sigue pudiendo mover con el dedo, la rueda y el ratón.
        this.autoActivo = this.dataset.auto === '1' && !menosMovimiento;

        this.v = 0;
        this.vObjetivo = this.autoActivo ? this.velocidadBase : 0;
        this.pos = 0;
        this.enPantalla = false;
        this.movido = false;
        this.arrastrando = false;

        this.#colocarInicio();
        this.#escuchar();
        this.#observarSeccion();
      }

      disconnectedCallback() {
        this.#parar();
        this.observadorSeccion?.disconnect();
      }

      get mitad() {
        return this.pista.scrollWidth / 2;
      }

      #colocarInicio() {
        // Si retrocede, hay que arrancar con margen a la izquierda o se queda pegada en 0.
        this.pos = this.velocidadBase < 0 ? this.mitad - 1 : 0;
        this.pista.scrollLeft = this.pos;
      }

      /* ── Movimiento ──────────────────────────────────────────────────────── */

      #latir = (t) => {
        if (!this.enPantalla) {
          this.rafId = null;
          return;
        }

        const dt = this.ultimoT ? Math.min((t - this.ultimoT) / 1000, 0.05) : 0;
        this.ultimoT = t;

        // Rampa: frena y arranca suave. Cortar en seco se siente roto.
        this.v += (this.vObjetivo - this.v) * 0.12;

        if (!this.arrastrando) {
          // Si algo externo movió la cinta (el dedo, la rueda), se resincroniza.
          if (Math.abs(this.pos - this.pista.scrollLeft) > 2) this.pos = this.pista.scrollLeft;

          if (Math.abs(this.v) > 0.01) {
            this.pos += this.v * dt;
            this.#envolver();
            this.pista.scrollLeft = this.pos;
          }
        }

        this.rafId = requestAnimationFrame(this.#latir);
      };

      // Las dos mitades de la cinta son idénticas, así que saltar una mitad no se ve.
      // OJO con el `< 0`: con `<= 0` la cinta arrancaba en pos 0, entraba aquí en el primer
      // fotograma y pegaba un salto de media vuelta — se veía el tirón.
      #envolver() {
        const m = this.mitad;
        if (m <= 0) return;
        if (this.pos >= m) this.pos -= m;
        else if (this.pos < 0) this.pos += m;
      }

      #arrancar() {
        if (this.rafId) return;
        this.ultimoT = 0;
        this.rafId = requestAnimationFrame(this.#latir);
      }

      #parar() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      #reanudar() {
        if (this.autoActivo) this.vObjetivo = this.velocidadBase;
      }

      #detener() {
        this.vObjetivo = 0;
      }

      /* ── Ratón y dedo ────────────────────────────────────────────────────── */

      #escuchar() {
        const pista = this.pista;

        // El ratón encima para la cinta; al salir, sigue.
        pista.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') this.#detener();
        });
        pista.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'mouse') this.#reanudar();
        });

        // En el celular, mientras se toca no avanza sola.
        pista.addEventListener('touchstart', () => this.#detener(), { passive: true });
        pista.addEventListener('touchend', () => {
          this.pos = pista.scrollLeft;
          this.#reanudar();
        });

        // La rueda del ratón manda mientras se usa.
        pista.addEventListener(
          'wheel',
          () => {
            this.#detener();
            clearTimeout(this.finRueda);
            this.finRueda = setTimeout(() => {
              this.pos = pista.scrollLeft;
              if (!pista.matches(':hover')) this.#reanudar();
            }, 400);
          },
          { passive: true }
        );

        // Arrastrar con el ratón (la manita).
        pista.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          this.arrastrando = true;
          this.movido = false;
          this.inicioX = e.clientX;
          this.inicioScroll = pista.scrollLeft;
          // OJO: la captura del puntero NO se pide aquí. Capturar en el pointerdown
          // redirige el `click` posterior a la pista. Se captura solo cuando el arrastre
          // empieza de verdad (abajo).
        });

        pista.addEventListener('pointermove', (e) => {
          if (!this.arrastrando) return;
          const dx = e.clientX - this.inicioX;
          if (!this.movido && Math.abs(dx) > UMBRAL_ARRASTRE) {
            this.movido = true;
            pista.dataset.arrastrando = '';
            try {
              pista.setPointerCapture(e.pointerId);
            } catch (_) {
              /* sin captura el arrastre sigue funcionando dentro de la cinta */
            }
          }
          if (this.movido) pista.scrollLeft = this.inicioScroll - dx;
        });

        const soltar = (e) => {
          if (!this.arrastrando) return;
          this.arrastrando = false;
          delete pista.dataset.arrastrando;
          this.pos = pista.scrollLeft;
          if (pista.hasPointerCapture && pista.hasPointerCapture(e.pointerId)) {
            try {
              pista.releasePointerCapture(e.pointerId);
            } catch (_) {
              /* el puntero ya se había liberado */
            }
          }
        };
        pista.addEventListener('pointerup', soltar);
        pista.addEventListener('pointercancel', soltar);

        // Arrastrar una foto no debe convertirse en el "arrastrar imagen" del navegador.
        pista.addEventListener('dragstart', (e) => e.preventDefault());
      }

      /* ── Fuera de pantalla no se gasta ni un fotograma ───────────────────── */

      #observarSeccion() {
        this.observadorSeccion = new IntersectionObserver(
          (entradas) => {
            this.enPantalla = entradas[0].isIntersecting;
            if (this.enPantalla) this.#arrancar();
            else this.#parar();
          },
          { rootMargin: '200px 0px' }
        );
        this.observadorSeccion.observe(this);
      }
    }

    customElements.define('lat-cinta-fotos', LatCintaFotos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lat-reels"] && !Shopify.designMode) return;
  try {
    
  /*
   * L'Atelier 33 — Cinta de reels.
   *
   * La cinta es un scroller de verdad y el avance lo empuja este código sobre `scrollLeft`.
   * Se hizo así, y no con una animación CSS, porque Yeremi pidió que se PARE al pasar el ratón
   * (si no, no da tiempo a hacer clic) y que se pueda ARRASTRAR con la manita — dos cosas
   * imposibles mientras el navegador anima el elemento él mismo.
   */
  if (!customElements.get('lat-reels')) {
    const UMBRAL_ARRASTRE = 5; // px que hay que mover para que deje de contar como clic

    class LatReels extends HTMLElement {
      connectedCallback() {
        this.pista = this.querySelector('[data-pista]');
        if (!this.pista || this.iniciado) return;
        this.iniciado = true;

        const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const ahorroDatos = navigator.connection && navigator.connection.saveData;

        this.velocidadBase = Number(this.dataset.velocidad || 40);
        if (this.dataset.direccion === 'derecha') this.velocidadBase *= -1;
        // Con el movimiento reducido o el auto apagado, la cinta se queda quieta:
        // se sigue pudiendo mover con el dedo, la rueda y el ratón.
        this.autoActivo = this.dataset.auto === '1' && !menosMovimiento;

        this.v = 0;
        this.vObjetivo = this.autoActivo ? this.velocidadBase : 0;
        this.pos = 0;
        this.enPantalla = false;
        this.movido = false;
        this.arrastrando = false;

        this.soloPosters = menosMovimiento || ahorroDatos;

        this.#colocarInicio();
        this.#escuchar();
        this.#observarSeccion();
      }

      disconnectedCallback() {
        this.#parar();
        this.observadorVideos?.disconnect();
        this.observadorSeccion?.disconnect();
      }

      get mitad() {
        return this.pista.scrollWidth / 2;
      }

      #colocarInicio() {
        // Si retrocede, hay que arrancar con margen a la izquierda o se queda pegada en 0.
        this.pos = this.velocidadBase < 0 ? this.mitad - 1 : 0;
        this.pista.scrollLeft = this.pos;
      }

      /* ── Movimiento ──────────────────────────────────────────────────────── */

      #latir = (t) => {
        if (!this.enPantalla) {
          this.rafId = null;
          return;
        }

        const dt = this.ultimoT ? Math.min((t - this.ultimoT) / 1000, 0.05) : 0;
        this.ultimoT = t;

        // Rampa: frena y arranca suave. Cortar en seco se siente roto.
        this.v += (this.vObjetivo - this.v) * 0.12;

        if (!this.arrastrando) {
          // Si algo externo movió la cinta (el dedo, la rueda), se resincroniza.
          if (Math.abs(this.pos - this.pista.scrollLeft) > 2) this.pos = this.pista.scrollLeft;

          if (Math.abs(this.v) > 0.01) {
            this.pos += this.v * dt;
            this.#envolver();
            this.pista.scrollLeft = this.pos;
          }
        }

        this.rafId = requestAnimationFrame(this.#latir);
      };

      // Las dos mitades de la cinta son idénticas, así que saltar una mitad no se ve.
      // OJO con el `< 0`: con `<= 0` la cinta arrancaba en pos 0, entraba aquí en el primer
      // fotograma y pegaba un salto de media vuelta — se veía el tirón y, de paso, se
      // descargaba el doble de videos (los del inicio más los del destino del salto).
      #envolver() {
        const m = this.mitad;
        if (m <= 0) return;
        if (this.pos >= m) this.pos -= m;
        else if (this.pos < 0) this.pos += m;
      }

      #arrancar() {
        if (this.rafId) return;
        this.ultimoT = 0;
        this.rafId = requestAnimationFrame(this.#latir);
      }

      #parar() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      #reanudar() {
        if (this.autoActivo) this.vObjetivo = this.velocidadBase;
      }

      #detener() {
        this.vObjetivo = 0;
      }

      /* ── Ratón, dedo y teclado ───────────────────────────────────────────── */

      #escuchar() {
        const pista = this.pista;

        // El ratón encima para la cinta; al salir, sigue.
        pista.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') this.#detener();
        });
        pista.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'mouse') this.#reanudar();
        });

        // Quien navega con teclado también necesita que se pare.
        pista.addEventListener('focusin', () => this.#detener());
        pista.addEventListener('focusout', () => {
          if (!pista.matches(':hover')) this.#reanudar();
        });

        // En el celular, mientras se toca no avanza sola.
        pista.addEventListener('touchstart', () => this.#detener(), { passive: true });
        pista.addEventListener('touchend', () => {
          this.pos = pista.scrollLeft;
          this.#reanudar();
        });

        // La rueda del ratón manda mientras se usa.
        pista.addEventListener(
          'wheel',
          () => {
            this.#detener();
            clearTimeout(this.finRueda);
            this.finRueda = setTimeout(() => {
              this.pos = pista.scrollLeft;
              if (!pista.matches(':hover')) this.#reanudar();
            }, 400);
          },
          { passive: true }
        );

        // Arrastrar con el ratón (la manita).
        pista.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          this.arrastrando = true;
          this.movido = false;
          this.inicioX = e.clientX;
          this.inicioScroll = pista.scrollLeft;
          this.punteroId = e.pointerId;
          // OJO: la captura del puntero NO se pide aquí. Capturar en el pointerdown
          // redirige el `click` posterior a la pista, y entonces la tarjeta nunca lo
          // recibe: un clic limpio dejaba de abrir la compra rápida. Se captura solo
          // cuando el arrastre empieza de verdad (abajo).
        });

        pista.addEventListener('pointermove', (e) => {
          if (!this.arrastrando) return;
          const dx = e.clientX - this.inicioX;
          if (!this.movido && Math.abs(dx) > UMBRAL_ARRASTRE) {
            this.movido = true;
            pista.dataset.arrastrando = '';
            try {
              pista.setPointerCapture(e.pointerId);
            } catch (_) {
              /* sin captura el arrastre sigue funcionando dentro de la cinta */
            }
          }
          if (this.movido) pista.scrollLeft = this.inicioScroll - dx;
        });

        const soltar = (e) => {
          if (!this.arrastrando) return;
          this.arrastrando = false;
          delete pista.dataset.arrastrando;
          this.pos = pista.scrollLeft;
          if (pista.hasPointerCapture && pista.hasPointerCapture(e.pointerId)) {
            try {
              pista.releasePointerCapture(e.pointerId);
            } catch (_) {
              /* el puntero ya se había liberado */
            }
          }
        };
        pista.addEventListener('pointerup', soltar);
        pista.addEventListener('pointercancel', soltar);

        // Si acabó de arrastrar, ese clic NO cuenta: si no, soltar sobre una
        // tarjeta abriría la compra rápida sin querer. Va en captura para
        // adelantarse a los manejadores del tema.
        pista.addEventListener(
          'click',
          (e) => {
            if (!this.movido) return;
            this.movido = false;
            e.preventDefault();
            e.stopPropagation();
          },
          true
        );

        // Un clic limpio sobre una tarjeta de producto abre la compra rápida.
        pista.addEventListener('click', (e) => {
          if (e.defaultPrevented) return;
          const tarjeta = e.target.closest('.latreel--producto');
          if (!tarjeta) return;
          // Si pulsó el botón de compra rápida, ya se encarga él.
          if (e.target.closest('quick-add-component')) return;

          const qa = tarjeta.querySelector('quick-add-component');
          if (!qa) return;
          const selector =
            qa.dataset.quickAddButton === 'add' ? '.quick-add__button--add' : '.quick-add__button--choose';
          const boton = qa.querySelector(selector);
          if (!boton) return;

          e.preventDefault();
          boton.click();
        });
      }

      /* ── Videos: solo los visibles, y solo entonces se descargan ─────────── */

      /* ⚠ ESTE OBSERVADOR NO SE CREA HASTA QUE LA CINTA ESTÁ CERCA DE VERSE.
         Su `root` es la PISTA (el carril horizontal), no la ventana, así que por sí solo
         no sabe nada de si la sección está en pantalla: daba por visibles los videos aunque
         la cinta estuviera 4.959 px más abajo, y la portada se descargaba 23,5 MB de video
         nada más abrirse. Lo dispara `#observarSeccion`. */
      #observarVideos() {
        if (this.observadorVideos) return;
        const videos = this.querySelectorAll('.latreel__video');
        if (!videos.length) return;

        if (this.soloPosters) {
          // Con datos limitados o movimiento reducido no se descarga ni un video.
          videos.forEach((v) => v.remove());
          return;
        }

        this.observadorVideos = new IntersectionObserver(
          (entradas) => {
            entradas.forEach((entrada) => {
              const video = entrada.target;
              if (entrada.isIntersecting) {
                if (!video.src && video.dataset.src) {
                  /* ⚠ EL HLS ES LA DIFERENCIA ENTRE 2,3 MB Y 11,7 MB (medido en la cinta).
                     El mp4 se descarga entero; el HLS baja solo los trozos que se ven. Pero
                     Chrome responde 'maybe' a `canPlayType`, que no es ninguna garantía —
                     así que se intenta el HLS y se deja una RED DE SEGURIDAD: si da error, o
                     si a los 3 s no ha conseguido ni un fotograma, se cambia al mp4. Así
                     ningún navegador se queda con el recuadro en negro. */
                  const puedeHls = video.dataset.hls && video.canPlayType('application/vnd.apple.mpegurl');
                  const alMp4 = () => {
                    if (video.dataset.enMp4) return;
                    video.dataset.enMp4 = '1';
                    video.src = video.dataset.src;
                    const r = video.play();
                    if (r) r.catch(() => {});
                  };

                  video.addEventListener('loadeddata', () => (video.dataset.listo = ''), { once: true });

                  if (puedeHls) {
                    video.src = video.dataset.hls;
                    video.addEventListener('error', alMp4, { once: true });
                    /* ⚠ La red de seguridad mira `networkState`, NO `readyState`.
                       Con `readyState < 2` a los 3 s se disparaba por LENTITUD y no por
                       fallo: en escritorio, con 9 videos cargando a la vez en 4G, los 9
                       se pasaban al mp4 sin necesidad y la cinta se iba a 16,7 MB.
                       `NETWORK_NO_SOURCE` (3) sí significa "no sé reproducir esto". */
                    setTimeout(() => {
                      if (video.networkState === 3 || video.error) alMp4();
                    }, 6000);
                  } else {
                    alMp4();
                  }
                }
                const p = video.play();
                if (p) p.catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { root: this.pista, rootMargin: '150px 0px' }
        );

        videos.forEach((v) => this.observadorVideos.observe(v));
      }

      /* ── Fuera de pantalla no se gasta ni un fotograma ───────────────────── */

      #observarSeccion() {
        this.observadorSeccion = new IntersectionObserver(
          (entradas) => {
            this.enPantalla = entradas[0].isIntersecting;
            if (this.enPantalla) {
              // Hasta aquí no se ha pedido ni un byte de video.
              this.#observarVideos();
              this.#arrancar();
            } else {
              this.#parar();
              this.querySelectorAll('.latreel__video').forEach((v) => v.pause());
            }
          },
          { rootMargin: '200px 0px' }
        );
        this.observadorSeccion.observe(this);
      }
    }

    customElements.define('lat-reels', LatReels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
